import React, { useState } from 'react';
import { Popover } from '@fiverr-private/popover';
import { EducationTooltipProps } from './types';
import { setSeen } from './utils';
import { useActive } from './useActive';
import { EducationTooltipContext } from './EducationTooltipContext';

const EducationTooltip = ({
  children,
  endOfLife,
  tooltipStorageKey,
  position = 'auto',
  onOpenChanged = () => undefined,
  disableFlip = false,
  variant = 'default',
}: EducationTooltipProps) => {
  const [active, setActive] = useActive({ endOfLife, tooltipStorageKey });
  const [inView, setInView] = useState(false);

  const onClose = () => {
    setSeen(tooltipStorageKey);
    setActive(false);
    onOpenChanged(false);
  };

  const onOpenChangedInner = (open: boolean) => {
    if (!open) {
      onClose();
    }
    onOpenChanged(open);
  };

  return (
    <EducationTooltipContext.Provider value={{ onClose, setInView, variant }}>
      <Popover
        isOpen={active && inView}
        position={position}
        onOpenChanged={onOpenChangedInner}
        disableFlip={disableFlip}
      >
        {children}
      </Popover>
    </EducationTooltipContext.Provider>
  );
};

EducationTooltip.displayName = 'EducationTooltip';

export default EducationTooltip;
